import React, { useCallback, useRef, useState } from "react";

import { Tooltip } from "components";

type PracticeTableTooltipProps = {
  title: React.ReactNode;
  children: (args: { ref: React.RefCallback<HTMLElement> }) => React.ReactNode;
  alwaysShow?: boolean;
};

// shared by historical-practice-data-table-view/MissingDataTable.tsx and all-fields-data-table-view/AllFieldsDataTable.tsx
export const PracticeTableTooltip = ({ title, children, alwaysShow = false }: PracticeTableTooltipProps) => {
  const targetElRef = useRef<HTMLElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const setTargetEl = useCallback((element: HTMLElement | null) => {
    targetElRef.current = element;
  }, []);

  // overflow is only checked on hover: a table has hundreds of these, so no per-cell state, observer or effect on mount
  const handleOpenChange = (shouldOpen: boolean) => {
    const targetEl = targetElRef.current;
    const isOverflowing = !!targetEl && (targetEl.scrollWidth > targetEl.clientWidth || targetEl.scrollHeight > targetEl.clientHeight);
    setIsOpen(shouldOpen && isOverflowing);
  };

  return (
    <Tooltip
      title={title}
      {...(!alwaysShow && { open: isOpen, onOpenChange: handleOpenChange })}
      arrow={false}
      classNames={{ root: "historical-practice-data-table-view-tooltip" }}
      className="historical-practice-data-table-view-tooltip-span"
    >
      {children({ ref: setTargetEl })}
    </Tooltip>
  );
};
